// extracted by mini-css-extract-plugin
module.exports = {"column":"idt-direction_column__un7ob","row":"idt-direction_row__1-jyl"};